import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { SidebarProvider } from './context/SidebarContext';
import { CsvProvider } from './context/CsvContext';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <SidebarProvider>
            <CsvProvider>
                <App />
            </CsvProvider>
        </SidebarProvider>
    </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
